module.exports = __webpack_public_path__ + "img/tab03.fdad81b9.png";